import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.replace";
import "D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from "vue";
import Cookies from "js-cookie";
import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";
import Opui from "op-ui";
import Parse from "@/components/parse";
import "op-ui/dist/css/index.css";
import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router, { resetRouter } from "@/router";
import "./icons"; // icon
import "./permission"; // permission control
import "./utils/error-log"; // error log

import * as filters from "./filters"; // global filters
import permissionDirective from "./directive/permission";
import setHeightTable from "./directive/el-table";
import noMoreClick from "./directive/noMoreClick";
import { Icon } from '@iconify/vue2';
import filter from "./filters/filter"; // 全局函数查询模板表个内容过滤
import componentList from "@/components/BusinessComponent";
import FormControls from "@/components/FormControls/index.js";
import request from "@/utils/request";
import "./public-path";
import Lodop from "@/utils/lodop.js";
import { getSearchObjData, splicingImgUrl } from "@/utils";
import axios from "axios";

// eslint-disable-next-line no-extend-native
String.prototype.trimoa = function () {
  return this.replace(/@/g, "");
};
//本地缓存面单地址
Vue.prototype.$cachePdfUrl = 'http://192.168.0.1:9000/face/';
Vue.prototype.$axios = axios;
Vue.prototype.$request = request;
Vue.prototype.$Lodop = Lodop;
Vue.prototype.$getSearchObjData = getSearchObjData;
Vue.prototype.$splicingImgUrl = splicingImgUrl;
Vue.prototype.$api = {
  common: {
    getQueryTemplate: "/public/sqlTemplate/queryComponents"
  },
  queryTemplate: {
    getTableHead: "/public/sqlTemplate/queryFields",
    getTableSetHead: "/public/publicUserListCustomField/query",
    saveTableSetHead: "/public/publicUserListCustomField/save"
  }
};
Vue.component('Icon', Icon);
Vue.prototype.imgPrefix = process.env.VUE_APP_OSS_URL;
var opcascader = componentList.opcascader,
  opfilter = componentList.opfilter,
  querytemplate = componentList.querytemplate,
  opvaluerange = componentList.opvaluerange,
  opsearchtree = componentList.opsearchtree,
  opsearchtable = componentList.opsearchtable,
  oporderby = componentList.oporderby,
  opshowtablerow = componentList.opshowtablerow,
  optablecontentfilter = componentList.optablecontentfilter,
  pdmUserNameSelect = componentList.pdmUserNameSelect;

// 先注册 op-ui 库，再注册自定义组件，确保自定义组件可以覆盖 op-ui 中的同名组件
Vue.use(Element, {
  size: Cookies.get("size") || "medium" // set element-ui default size
});

// 注册自定义业务组件（会覆盖 op-ui 中的同名组件）
Vue.use(opcascader).use(opfilter).use(querytemplate).use(opvaluerange).use(opsearchtree).use(opsearchtable).use(FormControls).use(oporderby).use(opshowtablerow).use(optablecontentfilter).use(pdmUserNameSelect);
// .use(optable)
Vue.use(filter);
Vue.use(Parse);
Vue.use(Opui);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mockXHR()
// }

// register global utility filters
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// pazu
import pazu from "@/utils/pazuclient.js";
if (!window.PAZU_Config) {
  window.PAZU_Config = {
    prot: "http",
    server: "localhost.pazu.4fang",
    port: 6894,
    license: ""
  };
}
Vue.use(pazu);

// register global utility directive
permissionDirective.install(Vue);
setHeightTable.install(Vue);
noMoreClick.install(Vue);
Vue.config.productionTip = false;
var instance = null;
var isFirstLoad = true;
function render() {
  return _render.apply(this, arguments);
} // 独立运行时
function _render() {
  _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var props,
      container,
      appId,
      menus,
      accessMenuRoutes,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          props = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          container = props.container, appId = props.appId;
          instance = new Vue({
            router: router,
            store: store,
            render: function render(h) {
              return h(App);
            }
          }).$mount(container ? container.querySelector("#app") : "#app");
          if (isFirstLoad) {
            _context.next = 11;
            break;
          }
          _context.next = 6;
          return store.dispatch("user/getMenus", appId);
        case 6:
          menus = _context.sent;
          _context.next = 9;
          return store.dispatch("permission/generateMenuRoutes", menus);
        case 9:
          accessMenuRoutes = _context.sent;
          router.addRoutes(accessMenuRoutes);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _render.apply(this, arguments);
}
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}
export function bootstrap(_x) {
  return _bootstrap.apply(this, arguments);
}
function _bootstrap() {
  _bootstrap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(props) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log(props);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _bootstrap.apply(this, arguments);
}
export function mount(_x2) {
  return _mount.apply(this, arguments);
}
function _mount() {
  _mount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(props) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          render(props);
          props.onGlobalStateChange(function (state, prev) {
            // state: 变更后的状态; prev 变更前的状态
            console.log(state["WMS"], "WMS");
            store.dispatch("tagsView/setOrReplaceView", state["WMS"]);
          });
          isFirstLoad = false;
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _mount.apply(this, arguments);
}
export function unmount(_x3) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(props) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          console.log(props);
          resetRouter();
          instance.$destroy();
          instance.$el.innerHTML = "";
          instance = null;
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _unmount.apply(this, arguments);
}
export function update(_x4) {
  return _update.apply(this, arguments);
}
function _update() {
  _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(props) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          console.log(props);
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _update.apply(this, arguments);
}